@if (showConfirmModal) {
<gtw-confirmation-modal
 
  [config]="confirmModalConfig"
  [visible]="showConfirmModal"
  (confirmed)="onConfirmGenerate()"
  (cancelled)="onCancelGenerate()"
  (closed)="onCancelGenerate()">
</gtw-confirmation-modal>
}

@if (processing) {
<div class="processing-overlay">
  <div class="processing-spinner">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
    <p class="processing-text">Processing... Please wait</p>
  </div>
</div>
}
